import React from "react";
import { MdPlayArrow } from "react-icons/md";

const FooterLogin: React.FC = () => {
  return (
    <footer>
      <a href="/primeiro-acesso-mi">
        <MdPlayArrow size={23} />
        Primeiro acesso
      </a>
      <a href="/troca-titularidade">
        <MdPlayArrow size={23} />
        Troca de Titularidade
      </a>
      <a
        href="https://www.ultragaz.com.br/institucional/politica-de-privacidade"
        target="_blank"
        rel="noreferrer"
      >
        <MdPlayArrow size={23} />
        Política de Privacidade
      </a>
    </footer>
  );
};

export default FooterLogin;
